export default {
  CANCEL: 'Cancelación de vuelo',
  RESCHEDULE: 'Reprogramación de vuelo',
  AIRPORT_CHANGE: 'Cambios de aeropuerto',
  SICKNESS: 'Familiar enfermo',
  DEATH: 'Fallecimiento',
  ISSUES: 'Motivo personal',
  OTHER: 'Otros'
}
